import Modal from "../components/modal.vue";
import Vue from "vue";
import {ModalStatus} from "../models/modalStatus";
import {ModalID} from "../enums/modalID";
import {IModalState} from "~/interfaces/modalInterfaces";

export default Vue.extend({
  components: {
    Modal
  },
  props: {
    index: {
      default: ''
    },
  },
  data: function() {
   return {
     modalStates: {},
     ModalStatus: ModalStatus,
     vueModalID: ModalID
   };
  },
  methods: {
    toggleModal(data: {event?: Event} & IModalState): void {
      if (data && data.event && typeof data.event.stopPropagation === 'function') {
        data.event.stopPropagation();
      }
      this.showModal(data.id, data.isVisible);
    },
    showModal(id: IModalState['id'], val: boolean = true): void {
      this.modalStateFor(id).isVisible = val;

      if ($('body').find('.v-modal').length <= 1) {
        if (val) {
          $('body').addClass("open-modal");
        } else {
          $('body').removeClass("open-modal");
        }
      }
    },
    hideModal(id: IModalState['id']): void {
      this.showModal(id, false);
    },
    modalStateFor(id: IModalState['id'], status?: ModalStatus): IModalState {
      if (!this.modalStates[id]) {
        if (!(status in ModalStatus)) {
          status = ModalStatus.None;
        }
        Vue.set(this.modalStates, id, {id: id, isVisible: false, status: status});
      }
      return this.modalStates[id];
    },
    emitHideModal(data = null) {
      if (data && data.event) {
        this.$emit('toggle-modal', data);
      } else {
        this.$emit('toggle-modal', { event: data, id: this.state.id, isVisible: false });
      }
    },
    resetModal(id: IModalState['id'], status: ModalStatus = null): void {
      this.hideModal(id);
      if (status !== null) {
        this.modalStateFor(id).status = status;
      }
    },
    hideOrReturn(e): void {
      if (this.$listeners.return) {
        this.$emit('return', e);
      } else {
        this.hideModal(e);
      }
    },
  }
});